import { ApiError } from './ApiError';

export class GatewayTimeoutError extends ApiError {
  constructor() {
    super(504, '');
  }
}
